module.exports = __webpack_public_path__ + "static/media/confirmed.46766815.svg";